import React from 'react';

const ScaledPage = ({ children }) => {

  // Calculate scale based on viewport
  const [scale, setScale] = React.useState(1);

  React.useEffect(() => {
    const calculateScale = () => {
      const designWidth = 1024; // Design width
      const designHeight = 768; // Design height

      const scaleX = window.innerWidth / designWidth;
      const scaleY = window.innerHeight / designHeight;

      // Use the smaller scale to fit content
      setScale(Math.min(scaleX, scaleY));
    };

    calculateScale();
    window.addEventListener('resize', calculateScale);
    window.addEventListener('orientationchange', calculateScale);

    return () => {
      window.removeEventListener('resize', calculateScale);
      window.removeEventListener('orientationchange', calculateScale);
    };
  }, []);

  return (
    <div
      id="scaled-container"
      style={{
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
        width: '1024px',
        height: '768px',
        position: 'absolute',
        left: `${(window.innerWidth - 1024 * scale) / 2}px`,
        top: `${(window.innerHeight - 768 * scale) / 2}px`,
      }}>
      {children}
    </div>
  );
}

export default ScaledPage;